(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    (function () {
  const SELECTOR = '.theme-accordion';

  function isDesignMode() {
    return typeof Shopify !== 'undefined' && Shopify.designMode;
  }

  function isItemDisabled(details) {
    return details.dataset.itemDisabled === 'true' || details.classList.contains('theme-accordion__item--disabled');
  }

  function canToggleItem(details) {
    return !isItemDisabled(details) || isDesignMode();
  }

  function closeDisabledItems(root) {
    if (isDesignMode()) return;
    getItems(root).forEach(function (details) {
      if (isItemDisabled(details) && details.open) {
        details.open = false;
        syncSummaryExpanded(details);
      }
    });
  }

  function storageKey(root) {
    return 'theme-accordion-open:' + (root.id || '');
  }

  function getItems(root) {
    return root.querySelectorAll(':scope > .theme-accordion__item');
  }

  function getOpenIndices(root) {
    const indices = [];
    getItems(root).forEach(function (details, index) {
      if (details.open) indices.push(index);
    });
    return indices;
  }

  function syncSummaryExpanded(details) {
    const summary = details.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    }
  }

  function syncAllItems(root) {
    getItems(root).forEach(syncSummaryExpanded);
  }

  function saveOpenState(root) {
    if (!isDesignMode() || !root.id) return;
    try {
      sessionStorage.setItem(storageKey(root), JSON.stringify(getOpenIndices(root)));
    } catch (e) {}
  }

  function restoreOpenState(root) {
    if (!isDesignMode() || !root.id) return false;
    try {
      const raw = sessionStorage.getItem(storageKey(root));
      if (!raw) return false;
      const indices = JSON.parse(raw);
      if (!Array.isArray(indices) || !indices.length) return false;

      const items = getItems(root);
      const singleOpen = root.dataset.singleOpen !== 'false';
      const toOpen = singleOpen ? [indices[indices.length - 1]] : indices;

      items.forEach(function (details) {
        details.open = false;
      });
      toOpen.forEach(function (index) {
        if (!items[index]) return;
        if (isItemDisabled(items[index]) && !isDesignMode()) return;
        items[index].open = true;
      });
      syncAllItems(root);
      return true;
    } catch (e) {
      return false;
    }
  }

  function enforceSingleOpen(root) {
    if (root.dataset.singleOpen === 'false') return;
    const items = getItems(root);
    let firstOpen = null;
    items.forEach(function (details) {
      if (!details.open) return;
      if (!firstOpen) {
        firstOpen = details;
        return;
      }
      details.open = false;
      syncSummaryExpanded(details);
    });
  }

  function applyOpenFirst(root) {
    const openFirst = root.dataset.openFirst !== 'false';
    const items = getItems(root);
    if (!openFirst || !items.length || getOpenIndices(root).length) return;
    for (let i = 0; i < items.length; i++) {
      if (isItemDisabled(items[i])) continue;
      items[i].open = true;
      syncSummaryExpanded(items[i]);
      enforceSingleOpen(root);
      return;
    }
  }

  function bindAccordion(root) {
    if (!root) return;

    if (root.dataset.accordionBound === 'true') {
      syncAllItems(root);
      if (!restoreOpenState(root)) {
        syncAllItems(root);
      }
      closeDisabledItems(root);
      return;
    }

    root.dataset.accordionBound = 'true';

    root.addEventListener(
      'toggle',
      function (event) {
        const details = event.target;
        if (!details.matches || !details.matches('.theme-accordion__item')) return;
        if (!root.contains(details)) return;

        if (!canToggleItem(details)) {
          details.open = false;
          syncSummaryExpanded(details);
          return;
        }

        syncSummaryExpanded(details);

        const singleOpen = root.dataset.singleOpen !== 'false';
        if (singleOpen && details.open) {
          getItems(root).forEach(function (other) {
            if (other !== details && other.open) {
              other.open = false;
              syncSummaryExpanded(other);
            }
          });
        }

        saveOpenState(root);
      },
      true
    );

    syncAllItems(root);
    if (!restoreOpenState(root)) {
      applyOpenFirst(root);
    } else {
      enforceSingleOpen(root);
    }
    closeDisabledItems(root);
  }

  function initAccordionsIn(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(bindAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAccordionsIn();
    });
  } else {
    initAccordionsIn();
  }

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(SELECTOR).forEach(saveOpenState);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAccordionsIn(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    initAccordionsIn(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
